<div class="row" #alertBanner>
  <div class="col-12" *ngIf="clientAlert">
    <div
      class="alert alert-dismissible fade show mb-0 release-notification"
      role="alert"
      [ngClass]="[getSeverityClass(clientAlert.severity), isClientExpanded ? 'expanded' : 'collapsed']"
    >
      <div class="d-flex align-items-center">
        <i class="me-2" [ngClass]="getSeverityIcon(clientAlert.severity)"></i>
        <div class="flex-grow-1 d-flex align-items-center flex-wrap gap-2">
          <strong class="notification-title">{{clientAlert?.title}}</strong>
          <span *ngIf="clientAlert?.subject">- {{ clientAlert?.subject }}</span>
          <a href="javascript:void(0)" class="expand-link ms-2" (click)="toggleClientAlertExpand()">
            <span *ngIf="!isClientExpanded">Show more <i class="ri-arrow-down-s-line"></i></span>
            <span *ngIf="isClientExpanded">Show less <i class="ri-arrow-up-s-line"></i></span>
          </a>
        </div>
      </div>

      <!-- Expanded Content -->
      <div class="expanded-content mt-2" *ngIf="isClientExpanded">
        <div class="notification-body mb-2" *ngIf="clientAlert?.message" [innerHTML]="clientAlert.message | safeHtml"></div>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-muted" *ngIf="clientAlert?.sentAt">
            {{clientAlert.sentAt | date:'medium'}}
          </small>
        </div>
      </div>

      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="onCloseClientAlert()"></button>
    </div>
  </div>
  <div class="col-12" *ngIf="newsAlert">
    <div
      class="alert alert-dismissible fade show mb-0 release-notification"
      role="alert"
      [ngClass]="[getSeverityClass(newsAlert.severity), isAlertExpanded ? 'expanded' : 'collapsed']"
    >
      <div class="d-flex align-items-center">
        <i class="me-2" [ngClass]="getSeverityIcon(newsAlert.severity)"></i>
        <div class="flex-grow-1 d-flex align-items-center flex-wrap gap-2">
          <strong class="notification-title">{{newsAlert?.title}}</strong>
          <a href="javascript:void(0)" class="expand-link ms-2" (click)="toggleExpand()">
            <span *ngIf="!isAlertExpanded">Show more <i class="ri-arrow-down-s-line"></i></span>
            <span *ngIf="isAlertExpanded">Show less <i class="ri-arrow-up-s-line"></i></span>
          </a>
        </div>
      </div>

      <!-- Expanded Content -->
      <div class="expanded-content mt-2" *ngIf="isAlertExpanded">
        <div class="notification-body mb-2" *ngIf="newsAlert?.body" [innerHTML]="newsAlert.body | safeHtml"></div>
        <div class="d-flex justify-content-between align-items-center">
          <div class="notification-actions" *ngIf="newsAlert?.latestReleaseUrl">
            <a [href]="newsAlert.latestReleaseUrl" target="_blank" class="btn btn-sm btn-outline-primary">
              <i class="ri-external-link-line me-1"></i>
              <span>View Release Notes</span>
            </a>
          </div>
          <small class="text-muted" *ngIf="newsAlert?.sentAt">
            {{newsAlert.sentAt | date:'medium'}}
          </small>
        </div>
      </div>

      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="onCloseAlert()"></button>
    </div>
  </div>
</div>
